angular.module('memberPortal').directive('memberPortalHeader', ["$rootScope", "$stateParams", "$state", "$http", "$window", "DataService", function($rootScope, $stateParams, $state, $http, $window, DataService) {
  return {
    restrict: 'EA',
    template: require('templates/member_portal/member_portal_header.html.slim'),
    link: function($scope) {
      $scope.data = DataService;
      $scope.member = DataService.member_details;
      $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
        var ref;
        $scope.isSidebarOpen = false;
        return $scope.title = (ref = toState.data) != null ? ref.title : void 0;
      });
      $scope.logout = function() {
        var url;
        url = `/websites/${DataService.domain}/members/logout`;
        return $http.delete(url).then(function(response) {
          url = $state.href('memberPortal.loginByHash', {
            hash: response.data.login_hash
          });
          $window.location = url;
          return true;
        }, function() {
          url = $state.href('memberPortal.loginByEmail');
          $window.location = url;
          return true;
        });
      };
      $scope.getHash = function() {
        return $stateParams.hash || $stateParams.m;
      };
      return $scope.toggleSidebar = function() {
        return $scope.isSidebarOpen = !$scope.isSidebarOpen;
      };
    }
  };
}]);
